import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { RouteGuardService } from './service/route-guard.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RouteGuard implements CanActivate {
  constructor(
    private authGuardService: RouteGuardService
  ) {  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return this.authGuardService.getRouteGuard().pipe(
         map(resp => {
           if (this.validateRoute(state.url, resp.urls)) {
            return true;
           } else {
            return false;
           }
        }),
       );
    }

  private validateRoute(url: string, allowedRoutes: string[]): boolean {
    for (const item of allowedRoutes) {
      if (url.includes(item)) {
        return true;
      }
    }

    return false;
  }
}
